export default "__VITE_ASSET__CBMHYFZF__"